import { useContext, useState } from "react";
import CloseIcon from "../../src/assets/img/closeIcon.svg";
import useTranslator from "../hooks/useTranslator";
import LandLordContext from "../context/landlord/LandLordContext";
import { toast } from "../helper/common";

const SendTenantEmailDrawer = ({
  user,
  isOpen,
  onClose,
  globalTenantDocuments,
  globalAllForensicDocuments,
  currentLang,
  globalTenantDocsHistory,
  globalMandatoryDocsList,
}) => {
  const { _t } = useTranslator();
  const { sendNoteToTenant } = useContext(LandLordContext);
  const [sendNoteLoading, setSendNoteLoading] = useState(false);
  const [selectedSections, setSelectedSections] = useState([]);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [isDocumentSelected, setIsDocumentSelected] = useState(false);
  const [note, setNote] = useState("");

  // toggle sections like KYC, Financial Score, Guarantor
  const toggleSection = (value, key) => {
    if (key === "documents") {
      setIsDocumentSelected((prev) => !prev);
      // clear docs if unchecked
      if (isDocumentSelected) {
        setSelectedDocuments([]);
      }
    } else {
      setSelectedSections((prev) =>
        prev.includes(value)
          ? prev.filter((item) => item !== value)
          : [...prev, value]
      );
    }
  };

  // toggle individual documents
  const toggleDocument = (docName) => {
    setSelectedDocuments((prev) =>
      prev.includes(docName)
        ? prev.filter((item) => item !== docName)
        : [...prev, docName]
    );
  };

  const handleSendNote = async () => {
    if (!note) {
      toast.error(_t("pleaseEnterANote"));
      return;
    }
    try {
      setSendNoteLoading(true);

      const finalSelectedItems = [
        ...selectedSections,
        ...(isDocumentSelected ? selectedDocuments : []),
      ];

      const data = {
        tenant_id: user?._id,
        selectedItems: finalSelectedItems,
        note,
      };

      await sendNoteToTenant(data);
      toast.success(
        _t(
          "noteSentSuccessfully",
          "Text used when landlord send mail to tenant"
        )
      );
      onClose();
    } catch (error) {
      toast.error(
        _t("FailedToSendNote", "Text used when landlord send mail to tenant")
      );
    } finally {
      setSendNoteLoading(false);
    }
  };

  return (
    <div>
      <div className="wrapper-modal" onClick={onClose}>
        <div
          className={`doc-history-popup send-email-drawer total-salary-modal ttt ${
            isOpen ? "open" : ""
          }`}
          onClick={(e) => e.stopPropagation()}
        >
          <span className="drawerIcon" onClick={onClose} />
          <div>
            <div className="doc-history-header send-feedback-header">
              <div className="d-flex align-items-center send-feedback-header-inner">
                <img
                  src={CloseIcon}
                  alt=""
                  className="send-email-close-btn"
                  onClick={onClose}
                />
                <h4 className="custom-modal-heading">
                  {_t("sendTenantEmailFor")}
                </h4>
              </div>
              <p>{_t("sendFeedbackToTheTenantDescription")}</p>
            </div>
            <div className="send-email-content">
              {/* Sections */}
              <div className="send-email-checkbox-container">
                <div className="send-email-section flag-card-grid">
                  {/* {[
                    {
                      label: _t(
                        "kycIdentification",
                        "Text used in send note popup"
                      ),
                    },
                    {
                      label: _t(
                        "financialScore",
                        "Text used in send note popup"
                      ),
                    },
                    { key: "documents", label: _t("documents") },
                    { label: _t("guarantor") },
                  ].map(({ key, label }, index) => (
                    <label key={index} className="send-email-checkbox">
                      <input
                        type="checkbox"
                        checked={
                          key === "documents"
                            ? isDocumentSelected
                            : selectedSections.includes(label)
                        }
                        onChange={() => toggleSection(label, key)}
                      />
                      <span>{label}</span>
                    </label>
                  ))} */}
                  {[
                    {
                      title: _t("idDocument"),
                      subtitle: _t(
                        "kycIdentification",
                        "Text used in send note popup"
                      ),
                      src: "/images/id-document.svg",
                    },
                    {
                      title: _t("financialScore"),
                      subtitle: _t(
                        "incomeAndStatements",
                        "Text used in send note popup"
                      ),
                      src: "/images/financial.svg",
                    },
                    {
                      key: "documents",
                      title: _t("documents"),
                      subtitle: _t("specificFiles"),
                      src: "/images/document.svg",
                    },
                    {
                      title: _t("guarantor"),
                      subtitle: _t("missingOrIncomplete"),
                      src: "/images/id-document-1.svg",
                    },
                  ].map(({ key, title, subtitle, src }, index) => (
                    <div
                      key={index}
                      onClick={() => toggleSection(title, key)}
                      className={`flag-card cursor-pointer d-flex align-items-center
                        ${selectedSections.includes(title) || (isDocumentSelected && key === "documents") ? "active" : ""}`}
                    >
                      <img src={src} alt="" />
                      <div>
                        <h5>{title}</h5>
                        <p>{subtitle}</p>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Documents */}
                {isDocumentSelected && (
                  <div>
                    <h4 className="custom-modal-heading custom-modal-heading2">
                      {_t("documents")}
                    </h4>
                    <div className="send-email-section document-sec">
                      {Object.entries(globalMandatoryDocsList)?.map(
                        ([key, value]) => {
                          const isPayslipKey = key
                            .toLowerCase()
                            .includes("payslip");

                          const payslipDocsCount = Object.keys(
                            globalTenantDocsHistory
                          ).filter((docKey) =>
                            docKey.toLowerCase().includes("payslip")
                          ).length;

                          if (isPayslipKey) {
                            const payslipOrder = [
                              "1st month payslip",
                              "2nd month payslip",
                              "3rd month payslip",
                            ];
                            const index = payslipOrder.indexOf(key);

                            if (index < payslipDocsCount) {
                              return null;
                            }
                          }

                          // normal missing document check
                          if (
                            !(key in globalTenantDocsHistory && !isPayslipKey)
                          ) {
                            const docName = _t(key, "", "fixed");
                            return (
                              <label
                                key={key}
                                className={`send-email-checkbox ${selectedDocuments.includes(docName) ? "selected" : ""}`}
                              >
                                <input
                                  type="checkbox"
                                  checked={selectedDocuments.includes(docName)}
                                  onChange={() => toggleDocument(docName)}
                                />
                                <span>{docName}</span>
                                <span className="missing-label">
                                  {_t("missing")}
                                </span>
                              </label>
                            );
                          }

                          return null;
                        }
                      )}
                      {[
                        ...new Set(
                          globalTenantDocuments.map((doc) => doc?.type)
                        ),
                      ].map((type, index) => {
                        const doc = globalTenantDocuments.find(
                          (d) => d.type === type
                        );

                        const docName =
                          globalAllForensicDocuments?.[doc?.file_name]
                            ?.localDocumentName?.[
                            currentLang === "en-us" ? "en" : "es"
                          ] ||
                          globalAllForensicDocuments?.[doc?.file_name]
                            ?.documentNameTranslated?.[
                            currentLang === "en-us" ? "en" : "es"
                          ] ||
                          globalAllForensicDocuments?.[doc?.file_name]
                            ?.documentName ||
                          _t(doc?.type, "", "fixed");

                        return (
                          <label
                            key={index}
                            className={`send-email-checkbox ${selectedDocuments.includes(docName) ? "selected-green" : ""}`}
                          >
                            <input
                              type="checkbox"
                              checked={selectedDocuments.includes(docName)}
                              onChange={() => toggleDocument(docName)}
                            />
                            <span>{docName}</span>
                            <span className="missing-label uploaded-label">
                              {_t("uploaded")}
                            </span>
                          </label>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>

              {/* Note */}
              <div className="forminput customInput">
                <label className="forminput label-text">
                  <h6 className="modal-label">{_t("personalNote")}</h6>
                </label>
                <textarea
                  className="form-control send-email-note modal-input"
                  placeholder={_t("personalNotePlaceholder")}
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="addGuarantorButtonWrapper add-button-wrapper d-flex align-items-center justify-content-center">
            <button
              className="btnNext addGuarantorButton send-email-btn d-flex align-items-center justify-content-center"
              onClick={handleSendNote}
              disabled={
                sendNoteLoading ||
                (selectedSections.length === 0 && !isDocumentSelected)
              }
            >
              {_t("sendViaEmail")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SendTenantEmailDrawer;
